import { Controller } from "@hotwired/stimulus"

// Manages icon selection for values and roles
// Usage:
//   <div data-controller="icon-picker" data-icon-picker-current-value="heart">
//     <button data-action="click->icon-picker#toggle" data-icon-picker-target="trigger">
//       <span data-icon-picker-target="preview">...</span>
//     </button>
//     <div data-icon-picker-target="dropdown" class="hidden">...</div>
//     <input type="hidden" data-icon-picker-target="input" name="model[icon]">
//   </div>
export default class extends Controller {
  static targets = ["trigger", "dropdown", "input", "preview"]
  static values = { current: String }

  connect() {
    // Close dropdown when clicking outside
    this.clickOutsideHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.clickOutsideHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
  }

  select(event) {
    event.preventDefault()
    const iconName = event.currentTarget.dataset.icon

    // Update hidden input
    this.inputTarget.value = iconName

    // Update preview - copy the SVG from the clicked button
    const svg = event.currentTarget.querySelector("svg")
    if (svg && this.hasPreviewTarget) {
      this.previewTarget.innerHTML = svg.outerHTML
    }

    // Mark selected
    this.dropdownTarget.querySelectorAll(".icon-option").forEach(el => {
      el.classList.remove("selected")
    })
    event.currentTarget.classList.add("selected")

    this.close()
  }
}
